module.exports = __webpack_public_path__ + "img/secret.7653b443.svg";